module.exports = __webpack_public_path__ + "img/pf.8e52562.svg";